"use client";

import { motion } from "framer-motion";
import { fadeUp, useMotionSafe } from "@/lib/motion";
import type { ReactNode } from "react";

type RevealProps = {
  children: ReactNode;
  className?: string;
  delay?: number;
  /** Use `li` when Reveal is a direct child of `ul` / `ol`. */
  as?: "div" | "li";
};

export function Reveal({
  children,
  className,
  delay = 0,
  as = "div",
}: RevealProps) {
  const { transition, viewport, prefersReducedMotion } = useMotionSafe();

  if (prefersReducedMotion) {
    const Tag = as;
    return <Tag className={className}>{children}</Tag>;
  }

  const MotionTag = as === "li" ? motion.li : motion.div;

  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
      variants={fadeUp}
      transition={{ ...transition, delay }}
    >
      {children}
    </MotionTag>
  );
}
